import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from '../reducers/Reducer';
import prodLogger from './middleware/ProdLogger';
import environmentNames from '../environmentNames';

function getMiddleware() {
    const middleware = [thunkMiddleware];

    if (process.env.NODE_ENV === environmentNames.PRODUCTION) {
        middleware.push(prodLogger);
    } else {
        const createLogger = require('redux-logger');

        const debugLogger = createLogger();
        middleware.push(debugLogger);
    }

    return middleware;
}

const createStoreWithMiddleware = applyMiddleware(...getMiddleware())(createStore);

const storeManager = {
    store: undefined,

    setStore(newStore) {
        this.store = newStore;
        return this;
    },

    getStore() {
        return this.store;
    },

    getState() {
        return this.getStore().getState();
    },

    configureStore(initialState = {}) {
        return createStoreWithMiddleware(reducer, initialState);
    },

    configureAndSetStore(initialState = {}) {
        const newStore = createStoreWithMiddleware(reducer, initialState);
        this.setStore(newStore);
        return newStore;
    }
};

export default storeManager;



/** WEBPACK FOOTER **
 ** ./src/store/StoreManager.js
 **/